/**
 * Virtual Try-On Integration for Shopify
 * Adds a try-on tab to shoe product pages
 */
(function() {
  // Configuration - adjust as needed for your store
  const CONFIG = {
    // The URL to your Try-On page in Shopify
    tryOnPageUrl: '/pages/virtual-try-on',
    
    // Product types that should show the try-on feature
    shoeTypes: ['shoes', 'footwear', 'sneakers', 'boots'],
    
    // Button and UI text
    buttonText: 'Try On This Shoe',
    tabTitle: 'Virtual Try-On',
    introText: 'See how these shoes look on your feet before buying!',
    
    // Where to add the try-on tab (first match will be used)
    insertLocations: [
      '.product__description-container',     // Dawn theme
      '.product-single__description',        // Debut theme
      '.product-description',                // Most themes
      '.product__info-container',            // Other themes
      '.product-detail'                      // Fallback
    ]
  };

  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  
  // Initialize when the page is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Main initialization function
  function initialize() {
    // Get the product data
    const product = getProductData();
    if (!product) {
      console.log('Could not find product data');
      return;
    }
    
    // Check if this is a shoe product
    if (!isShoeProduct(product)) {
      return;
    }
    
    // Add the try-on tab to the page
    addTryOnTab(product);
  }
  
  // Get product data from the page
  function getProductData() {
    // Look for Shopify's product JSON
    const jsonSelectors = [
      '#ProductJson-product-template',
      '[data-product-json]',
      'script[type="application/json"][data-product-json]',
      '#ProductJson-template'
    ];
    
    for (const selector of jsonSelectors) {
      const element = document.querySelector(selector);
      if (element && element.textContent.trim()) {
        try {
          return JSON.parse(element.textContent);
        } catch (e) {
          console.log('Error parsing product JSON:', e);
        }
      }
    }
    
    // Fallback: extract basic info from the page
    const productTitle = document.querySelector('h1.product-single__title, .product__title h1, .product-title')?.textContent.trim();
    const productId = document.querySelector('[name="id"][data-product-id]')?.getAttribute('data-product-id');
    
    if (productTitle && productId) {
      return {
        id: productId,
        title: productTitle
      };
    }
    
    return null;
  }
  
  // Check if a product is a shoe/footwear
  function isShoeProduct(product) {
    // Check product type
    if (product.type && CONFIG.shoeTypes.some(type => 
      product.type.toLowerCase().includes(type.toLowerCase())
    )) {
      return true;
    }
    
    // Check product tags
    if (product.tags && Array.isArray(product.tags)) {
      if (product.tags.some(tag => 
        CONFIG.shoeTypes.includes(tag.toLowerCase())
      )) {
        return true;
      }
    }
    
    // Check product title for keywords
    if (product.title) {
      const title = product.title.toLowerCase();
      if (CONFIG.shoeTypes.some(type => title.includes(type))) {
        return true;
      }
    }
    
    // Check DOM for shoe-specific classes/data
    const shoeSelectors = [
      '[data-product-type="Footwear"]', 
      '[data-product-type="Shoes"]'
    ];
    
    for (const selector of shoeSelectors) {
      if (document.querySelector(selector)) {
        return true;
      }
    }
    
    return false;
  }
  
  // Add the try-on tab to the product page
  function addTryOnTab(product) {
    // Find where to insert the try-on section
    let insertPoint = null;
    
    for (const selector of CONFIG.insertLocations) {
      const element = document.querySelector(selector);
      if (element) {
        insertPoint = element;
        break;
      }
    }
    
    // If no insertion point found, try a generic fallback
    if (!insertPoint) {
      insertPoint = document.querySelector('.product, .product-single, main');
    }
    
    if (!insertPoint) {
      console.log('Could not find location to insert try-on tab');
      return;
    }
    
    // Create the try-on tab HTML
    const tryOnSection = document.createElement('div');
    tryOnSection.className = 'try-on-section';
    tryOnSection.innerHTML = `
      <div class="try-on-header">
        <h3>${CONFIG.tabTitle}</h3>
      </div>
      <div class="try-on-content">
        <p>${CONFIG.introText}</p>
        <button id="try-on-button" class="try-on-button">${CONFIG.buttonText}</button>
      </div>
    `;
    
    // Add the section to the page
    insertPoint.after(tryOnSection);
    
    // Add button click handler
    document.getElementById('try-on-button').addEventListener('click', function() {
      openTryOnModal(product);
    });
    
    // Add necessary styles
    addStyles();
  }
  
  // Open the try-on experience in a modal
  function openTryOnModal(product) {
    // Create a modal
    const modal = document.createElement('div');
    modal.className = 'try-on-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    
    modal.innerHTML = `
      <div class="try-on-modal-overlay"></div>
      <div class="try-on-modal-container">
        <div class="try-on-modal-header">
          <h3>Virtual Try-On: ${product.title}</h3>
          <button class="try-on-modal-close" aria-label="Close">&times;</button>
        </div>
        <div class="try-on-modal-content">
          <iframe 
            src="${CONFIG.tryOnPageUrl}?productId=${product.id}&productTitle=${encodeURIComponent(product.title)}" 
            frameborder="0" 
            allow="camera; accelerometer; gyroscope" 
            title="Virtual Try-On"
            style="width: 100%; height: 600px; border: none;"
          ></iframe>
        </div>
      </div>
    `;
    
    // Add modal to the page
    document.body.appendChild(modal);
    
    // Prevent page scrolling
    document.body.style.overflow = 'hidden';
    
    // Close button handler
    modal.querySelector('.try-on-modal-close').addEventListener('click', function() {
      document.body.removeChild(modal);
      document.body.style.overflow = '';
    });
    
    // Close when clicking overlay
    modal.querySelector('.try-on-modal-overlay').addEventListener('click', function() {
      document.body.removeChild(modal);
      document.body.style.overflow = '';
    });
    
    // Close on escape key
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        document.body.removeChild(modal);
        document.body.style.overflow = '';
        document.removeEventListener('keydown', escHandler);
      }
    });
  }
  
  // Add required CSS styles
  function addStyles() {
    // Only add styles once
    if (document.getElementById('try-on-styles')) {
      return;
    }
    
    const styles = document.createElement('style');
    styles.id = 'try-on-styles';
    styles.textContent = `
      /* Try-On Section */
      .try-on-section {
        margin: 30px 0;
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
      }
      
      .try-on-header h3 {
        margin-top: 0;
        font-size: 18px;
        color: #333;
      }
      
      .try-on-button {
        background-color: #3052D6;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;
        transition: background-color 0.2s;
      }
      
      .try-on-button:hover {
        background-color: #2542B6;
      }
      
      /* Modal */
      .try-on-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .try-on-modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
      }
      
      .try-on-modal-container {
        position: relative;
        width: 90%;
        max-width: 1000px;
        max-height: 90vh;
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        z-index: 1;
      }
      
      .try-on-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid #e5e5e5;
      }
      
      .try-on-modal-header h3 {
        margin: 0;
        font-size: 18px;
        color: #333;
      }
      
      .try-on-modal-close {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #777;
      }
      
      .try-on-modal-content {
        flex-grow: 1;
        overflow: hidden;
      }
      
      /* Responsive styles */
      @media (max-width: 768px) {
        .try-on-modal-container {
          width: 100%;
          height: 100%;
          max-width: none;
          max-height: none;
          border-radius: 0;
        }
        
        .try-on-modal-content iframe {
          height: calc(100vh - 60px);
        }
      }
    `;
    
    document.head.appendChild(styles);
  }
})();// At the top of your script, add:
const DEBUG = true;

// Then add this function:
function debug(message) {
  if (DEBUG) {
    console.log('[Try-On Debug]', message);
  }
}

// Then add logging throughout your code:
function initialize() {
  debug('Initializing try-on integration');
  
  // Get the product data
  const product = getProductData();
  if (!product) {
    debug('Could not find product data');
    return;
  }
  
  debug('Found product data:', product);
  
  // Check if this is a shoe product
  if (!isShoeProduct(product)) {
    debug('Product is not detected as footwear');
    return;
  }
  
  debug('Product is detected as footwear, adding try-on tab');
  
  // Add the try-on tab to the page
  addTryOnTab(product);
}